import { createSlice } from "@reduxjs/toolkit";
import {
  deleteUserProfile,
  getUserProfile,
  postChangePassword,
  postUserProfile,
  varibaleChargeRate,
} from "../../thunks/common-thunks/commonThunk";
import { message } from "antd";

const initialState = {
  isLoading: false,
  isPasswordLoading: false,
  userGuidlineAcceptance: null,
  profileStatus: "idle", // "idle" | "loading" | "success" | "failed"
  profileStatusMsg: null,
  error: null,
  user: null,
  userId: null,
  clientId: null,
  professionalGuidelines: false,
  chatsMonitered: false,
  variableChargeRates: [],
};

export const userProfileSlice = createSlice({
  name: "userprofile",
  initialState,
  reducers: {
    RESET_USER: (state) => {
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserProfile.pending, (state) => {
        state.isLoading = true;
        state.profileStatus = "loading";
        state.error = null;
        state.profileStatusMsg = null;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profileStatus = "success";
        state.user = action.payload.user;
        state.userType = action.payload.usertype;
        state.clientId = action.payload.user?.client_mongo_id;
        state.profileStatusMsg = action.payload.message;
        state.userGuidlineAcceptance =
          action.payload.user?.docu_sign_acceptance;
        state.userId = action.payload.user?.mongo_id;
        state.chatsMonitered = action.payload.user?.chats_monitored;
        state.professionalGuidelines =
          action.payload.user?.professional_guidelines;
        state.error = null;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.profileStatus = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //post the user details
    builder
      .addCase(postUserProfile.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.updateUserDetails = false;
      })
      .addCase(postUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateUserDetails = action.payload;
        message.success(action.payload.message);
      })
      .addCase(postUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    //post the user profile delete
    builder
      .addCase(deleteUserProfile.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.deleteUserDetails = false;
      })
      .addCase(deleteUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.deleteUserDetails = action.payload;
      })
      .addCase(deleteUserProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    //change the user password
    builder
      .addCase(postChangePassword.pending, (state, action) => {
        state.isLoading = true;
        state.requestStatus = "changePassword";
        state.error = null;
        state.updateChangePassword = false;
      })
      .addCase(postChangePassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateChangePassword = action.payload;
      })
      .addCase(postChangePassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    builder
      .addCase(varibaleChargeRate.pending, (state) => {
        state.isLoading = true;
        state.requestStatus = "loading";
        state.error = null;
        state.updateChangePassword = false;
      })

      .addCase(varibaleChargeRate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.requestStatus = "success";

        state.variableChargeRates = action.payload;
      })

      .addCase(varibaleChargeRate.rejected, (state, action) => {
        state.isLoading = false;
        state.requestStatus = "failed";
        state.error = action.payload;

        message.error("Something went wrong!");
      });
  },
});
export const { RESET_USER } = userProfileSlice.actions;
export default userProfileSlice.reducer;
